// frontend_react/src/pages/supplierInvoice/ProductAutocomplete.jsx

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { searchProducts } from "../../services/supplierInvoiceApi";
import { learnSupplierInvoiceMatching } from "../../services/supplierInvoiceApi";
import { useAdminScope } from "../../context/AdminScopeContext";

export default function ProductAutocomplete({
  value,
  onSelect,
  line,
  placeholder = "Rechercher produit...",
}) {
  const [query, setQuery] = useState(value || "");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const { selectedCompanyUuid } = useAdminScope();

  useEffect(() => {
    setQuery(value || "");
  }, [value]);

  useEffect(() => {
    if (!query || query.length < 2) {
      setResults([]);
      return;
    }

    const timeout = setTimeout(async () => {
      try {
        const res = await searchProducts(query, {
          companyUuid: selectedCompanyUuid,
        });
        setResults(res.data.results || []);
        setOpen(true);
      } catch (err) {
        console.error("Erreur recherche produit :", err);
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [query]);

  const handleSelect = async (product) => {
    onSelect(product);
    setQuery(product.designation || product.uuid);
    setOpen(false);

    try {
      await learnSupplierInvoiceMatching(
        {
          designation: line.designation,
          supplier_ref: line.supplier_ref,
          ean: line.ean,
          product_uuid: product.uuid,
          source: "user",
          confidence: 1,
        },
        {
          companyUuid: selectedCompanyUuid,
        }
      );
    } catch (err) {
      console.error("Erreur apprentissage fournisseur :", err);
    }
  };

  return (
    <Wrapper>
      <Input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder}
        onFocus={() => setOpen(true)}
      />

      {open && results.length > 0 && (
        <Dropdown>
          {results.map((p) => (
            <Item key={p.uuid} onMouseDown={() => handleSelect(p)}>
              <strong>{p.designation}</strong>
              <small>{p.reference || p.ean || p.uuid}</small>
            </Item>
          ))}
        </Dropdown>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  width: 320px;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border-radius: 12px;
  background: #15203f;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.12);
  outline: none;

  &:focus {
    border-color: #4ea3e9;
  }
`;

const Dropdown = styled.div`
  position: absolute;
  top: 110%;
  left: 0;
  right: 0;
  background: #0b1329;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  z-index: 50;
  overflow: hidden;
`;

const Item = styled.div`
  padding: 10px 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 4px;

  strong {
    color: white;
    font-size: 14px;
  }

  small {
    color: rgba(255, 255, 255, 0.55);
    font-size: 12px;
  }

  &:hover {
    background: #15203f;
  }
`;